import uniqid from 'uniqid'
export const academics = [
    {
        id: uniqid(),
        type: 'school',
        school: 'Centro de Diseño Digital',
        startDate: '2012-02',
        endDate: '2015-09',
        title: 'Especializacion en Diseño Grafico',
        isEditing: false,
    },
    {
        id: uniqid(),
        type: 'school',
        school: 'funval',
        startDate: '2010-01',
        endDate: '2013-08',
        title: 'Tecnico en reparacion de celulares',
        isEditing: false,
    },
]
